import { LOCALES } from 'i18n/locales';

export const assetOwnersIntl = {
    [LOCALES.ENGLISH]: {
        'assetOwners.menu.assetsInAOIOwners': 'Organisations with assets in your area of interest',
        'assetOwners.menu.operationalZones': 'Organisations who operate in the vicinity',
        'assetOwners.menu.nationalRegional': 'Organisations with National or Regional coverage',
        'assetOwners.businessContactDetails': 'Business contact details',
        'assetOwners.emergencyContactDetails': 'Emergency contact details',
        'assetOwners.disclaimer.title': 'view copyright / disclaimer',
        'assetOwners.disclaimer': 'Disclaimer',
        'assetOwners.copyright': 'Copyright',
        'assetOwners.standardGuidance': 'Standard Guidance',
        'assetOwners.noAssets.message': 'There are no asset owners in this region',
        'assetOwners.error': 'Error occured getting assets for this region',
        'assetOwners.loading': 'Loading asset owners for this region...'
    },
    [LOCALES.WELSH]: {
        'assetOwners.menu.assetsInAOIOwners': 'Sefydliadau sydd ag asedau yn eich ardal o ddiddordeb',
        'assetOwners.menu.operationalZones': 'Sefydliadau sy\'n gweithredu yn y cyffiniau',
        'assetOwners.menu.nationalRegional': 'Sefydliadau sydd â chwmpas Cenedlaethol neu Ranbarthol',
        'assetOwners.businessContactDetails': 'Manylion cyswllt busnes',
        'assetOwners.emergencyContactDetails': 'Manylion cyswllt mewn argyfwng',
        'assetOwners.disclaimer.title': 'gweld hawlfraint / ymwadiad',
        'assetOwners.disclaimer': 'Ymwadiad',
        'assetOwners.copyright': 'Hawlfraint',
        'assetOwners.standardGuidance': 'Arweiniad Safonol',
        'assetOwners.noAssets.message': 'Nid oes unrhyw berchnogion asedau yn y rhanbarth hwn',
        'assetOwners.error': 'Digwyddodd gwall cael asedau ar gyfer y rhanbarth hwn',
        'assetOwners.loading': 'Llwytho perchnogion asedau ar gyfer y rhanbarth hwn...'

    }
};
